/* eslint-disable spellcheck/spell-checker */

import { queryEncode } from 'cio/helpers/query';

export const CONFIG = Object.freeze({
  campaign: {
    id: '1',
    name: 'Demo Campaign',
    type: 'behavioral',
    anchors: queryEncode([{ negate: false, segments: [1], type: 'segments_negatable' }]),
    workflow_action_ids: ['1', '2'],
    edges: [
      {
        from: '1',
        to: '2',
        type: 'continue',
      },
    ],
  },
  actions: [
    {
      id: '1',
      type: 'filter_match_delay_action',
      campaign_id: '1',
    },
    {
      id: '2',
      type: 'exit_action',
      campaign_id: '1',
    },
  ],
  notes: [],
});
